import { scheduledEventModel } from 'APP/model/model';
import Entities from 'STORE';

export const cancelScheduledEvent = async (eventId: string): Promise<void> => {
  await scheduledEventModel.cancelScheduledEvent({ eventId });

  Entities.scheduledEvents.removeScheduledEvent(eventId);
};
